const initialState = {
    isAuthenticated: !!sessionStorage.getItem('userAccessToken'),
  };
  
  const authReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'LOGIN':
        return { ...state, isAuthenticated: true };
      case 'LOGOUT':
        sessionStorage.clear(); // Clear session data on logout
        return { ...state, isAuthenticated: false };
      default:
        return state;
    }
  };
  
  export default authReducer;
  